import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
	orderExtra: {},
	mallOrderExtra: {},
	editAddress: {},
	istore: {},
	icart: {},
	allcart: {},
	locationInfo: {},
	searchLocationInfo: {},
	erranderExtra: {
		partData: {},
		thumbs:{},
		input_buy: {},
		input_accept: {},
		yinsihao_status: true
	},
	erranderSceneId: 0,
	erranderStoreExtra: {
		address_input: {
			realname: '',
			mobile: '',
			address: '',
			number: '',
			location_x: '',
			location_y: ''
		}
	},
	erranderStoreSceneMode: '',
	erranderStoreSceneOrderId: 0,
	erranderStoreOrderSearch: {},
	addressUser: {},
	cart_animate: {},
	pinTuanExtra: {},
	country: {}
}

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
})


// WEBPACK FOOTER //
// ./src/store/index.js